var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPumpkins = function SvgPumpkins(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: "auto",
    viewBox: "0 0 95 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pumpkins_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.941 37.037c-.616.514-2.633.43-3.26.504-.629.075-1.215-.023-1.772-.153-2.33-.539-4.487-1.671-5.494-3.97l-.892-2.071c.515.162 3.15-.054 3.735-.07.59-.013 1.26-.22 1.847-.717.667-.562 1.155-1.457 1.301-2.271.015-.093.027-.18.033-.27.026-.322.13-.643.295-.94a2.587 2.587 0 0 1 .822-.918c.072-.051.146-.093.217-.13.133-.067.267-.112.404-.136 0 0 .013 0 .02-.003.261-.047.53-.098.744-.029.274.093.435.369.525.682.276.95-.016 2.218-.383 3.415-.37 1.202-.823 2.428-.901 3.572-.096 1.449 1.794 2.966 2.757 3.51l.002-.005Z",
    fill: "#715D98"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30.621 36.692a3.73 3.73 0 0 1-1.94.85c-.634.071-1.215-.024-1.772-.154-1.127-.26-2.215-.66-3.155-1.26.485.18.986.329 1.504.445.557.13 1.138.226 1.771.154a3.74 3.74 0 0 0 1.947-.847c-.963-.544-1.533-1.717-1.435-3.17.075-1.139.532-2.37.9-3.567.338-1.09.605-2.245.44-3.158a1.307 1.307 0 0 1 .32-.098c.26-.048.523-.101.742-.03.274.093.435.37.525.683.277.95-.015 2.218-.382 3.415-.37 1.202-.83 2.425-.902 3.571-.095 1.45.48 2.625 1.437 3.166Z",
    fill: "#715D98",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.958 34.885c-.336-.345-.443-.92-.383-1.552.132-1.316.919-2.667 1.356-4.002.215-.652.29-1.263.364-1.886.054-.428.121-.855.256-1.287a1.89 1.89 0 0 1 .217-.13c-.197.554-.253 1.1-.316 1.637-.074.597-.175 1.18-.389 1.794-.22.637-.504 1.26-.755 1.895-.467 1.172-.88 2.64-.213 3.327.072.077-.068.273-.137.204Z",
    fill: "#715D98",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.965 33.063c-.009-.486.094-1.009.282-1.534.176-.486.432-.937.727-1.388.304-.454.596-.913.69-1.42.112-.578.017-1.088.062-1.64.065-.127.143-.241.226-.353-.066.348-.055.674-.054.995.01.353.01.714-.083 1.102-.114.483-.4.926-.687 1.36-.308.465-.575.925-.745 1.44-.16.466-.238.928-.234 1.358-.002.133-.186.212-.19.077l.006.002ZM25.607 33.429c-.087-.82.177-1.815.715-2.691.081-.133-.049-.226-.13-.093-.583.953-.864 2.02-.768 2.911.014.128.2-.005.183-.127ZM29.54 30.098c.195-.73.521-1.473.653-2.195.106-.594.086-1.186-.213-1.525-.072-.077-.238.093-.165.17.678.766-.136 2.404-.45 3.574-.04.14.142.12.18-.021l-.004-.003ZM27.974 33.264c-.094-.897.318-1.964.716-2.938.398-.987.812-2.006.821-2.95.002-.133-.188-.056-.19.076-.013 1.919-1.725 4.069-1.53 5.94.014.127.2-.006.183-.128ZM28.214 34.028c.423-1.048.75-2.104.977-3.152.03-.139-.15-.117-.182.02a19.132 19.132 0 0 1-.96 3.095c-.057.138.108.175.165.037Z",
    fill: "#715D98",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.199 36.375c-3.004 5.896-.91 11.736 4.058 14.267.474.241.961.443 1.447.61a9.845 9.845 0 0 0 2.112.462 10.177 10.177 0 0 0 2.955 2.247c.989.504 2.015.833 3.051 1a10.49 10.49 0 0 0 1.945 1.512c.21.127.43.252.658.368 4.962 2.529 10.918.79 13.922-5.107 3.004-5.897 1.924-13.727-3.044-16.258a6.865 6.865 0 0 0-1.353-.522 7.77 7.77 0 0 0-1.801-.276 7.479 7.479 0 0 0-2.5-2.083c-1.146-.583-2.407-.838-3.69-.803a8.497 8.497 0 0 0-1.049-1.25 7.27 7.27 0 0 0-1.767-1.268c-4.968-2.53-11.935 1.194-14.941 7.096l-.003.005Z",
    fill: "#F68F38"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.163 29.853c1.098.56 2.004 1.395 2.7 2.411 1.236-.032 2.439.207 3.538.767a7.12 7.12 0 0 1 2.393 1.995c1.055.042 2.08.283 3.022.763 4.77 2.43 5.807 9.932 2.928 15.584-2.88 5.653-8.588 7.317-13.347 4.893a9.814 9.814 0 0 1-2.494-1.799 9.842 9.842 0 0 1-2.921-.96 9.724 9.724 0 0 1-2.83-2.157 9.88 9.88 0 0 1-3.408-1.021c-4.759-2.425-6.768-8.02-3.888-13.673 2.88-5.652 9.558-9.223 14.317-6.798l-.01-.005Z",
    fill: "#F68F38",
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M10.586 39.266c-2.23 4.379-1.948 8.728.115 11.978a9.844 9.844 0 0 0 2.113.462 10.178 10.178 0 0 0 2.954 2.247c.99.504 2.015.833 3.052 1 .576.567 1.227 1.08 1.945 1.512 3.911-.187 7.67-2.517 9.933-6.96 2.414-4.739 2.471-10.593.25-14.56a7.765 7.765 0 0 0-1.802-.275 7.477 7.477 0 0 0-2.5-2.083c-1.146-.583-2.406-.838-3.69-.803a8.497 8.497 0 0 0-1.048-1.25c-4.42.657-8.959 4.094-11.317 8.722l-.005.01Z",
    fill: "url(#pumpkins_svg__b)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.713 39.693c-3.004 5.897-.91 11.737 4.058 14.268 4.967 2.53 10.923.791 13.927-5.105 3.004-5.897 1.923-13.727-3.044-16.258-4.968-2.53-11.934 1.193-14.941 7.095Z",
    fill: "#F68F38"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.11 39.842c-2.88 5.652-.871 11.248 3.888 13.673 4.759 2.424 10.467.76 13.346-4.893a14.844 14.844 0 0 0 1.564-5.734c.279-4.177-1.237-8.191-4.481-9.844-3.244-1.653-7.383-.519-10.598 2.162a14.845 14.845 0 0 0-3.72 4.636Z",
    fill: "#F68F38",
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.608 37.15c-.168.229.025 1.176.063 1.45.07.49.192.973.353 1.443.324.934 1.549 3.216 1.549 3.216s-.808.825-.811.897c.001.06 1.504 1.321 2.165 1.684l.889-1.165c.443.314 1.887.982 1.887.982l-.428 1.406c.805.223 1.64.348 2.481.369.116-.369.23-.746.345-1.115 2.028.539 4.145.721 6.082-.056-3.528 5.496-9.524 4.754-12.785 2.517-1.605-1.098-2.727-2.913-3.16-4.818-.524-2.293-.086-4.904 1.368-6.804l.002-.005Z",
    fill: "url(#pumpkins_svg__c)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.824 35.203c.008 3.614 1.976 6.742 5.22 8.395 3.243 1.652 6.93 1.405 9.86-.713.277-4.177-1.238-8.191-4.482-9.844-3.244-1.652-7.383-.519-10.598 2.162Z",
    fill: "#F68F38",
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.463 40.413c.09-.048 1.707-.44 2.912-.722a1.25 1.25 0 0 1 1.542 1.106l.002.061c-.067 1.096-.436 2.258-1.341 2.967-.523.409-1.2.592-1.832.404-1.197-.356-1.65-1.757-1.64-2.895.004-.345.058-.746.357-.921Z",
    fill: "url(#pumpkins_svg__d)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.633 40.413c.085-.05 1.602-.414 2.734-.68.7-.164 1.386.319 1.45 1.04 0 .027.005.043.005.056-.065 1.03-.407 2.126-1.262 2.786-.491.385-1.129.555-1.722.38-1.12-.337-1.546-1.65-1.54-2.717.002-.326.055-.7.335-.865Z",
    fill: "#3C3334"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.156 38.742c-.006-.104-.634-1.64-1.11-2.791a1.256 1.256 0 0 0-1.8-.61l-.05.034c-.854.695-1.582 1.675-1.628 2.821-.023.663.219 1.321.735 1.725.988.764 2.39.315 3.308-.354.281-.204.574-.483.54-.828l.005.003Z",
    fill: "url(#pumpkins_svg__e)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.061 38.606c-.009-.098-.598-1.541-1.038-2.621a1.177 1.177 0 0 0-1.69-.573c-.02.016-.036.021-.047.03-.797.65-1.488 1.568-1.528 2.65-.022.624.207 1.242.692 1.616.926.72 2.244.294 3.106-.33.26-.188.54-.453.508-.777l-.003.005ZM20.861 42.643c.238.228.509.366.802.421.33.061.658-.159.734-.488.07-.279.085-.578.04-.889a.651.651 0 0 0-.967-.472c-.248.14-.458.308-.634.486a.668.668 0 0 0 .02.939l.005.003Z",
    fill: "#3C3334"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.69 36.758c-.168.228.024 1.176.062 1.449.072.49.193.974.354 1.443.324.934 1.792 3.42 1.792 3.42s-.807.826-.811.897c.002.062 1.26 1.117 1.922 1.48l.888-1.164c.444.313 1.888.981 1.888.981l-.428 1.407c.804.222 1.64.347 2.481.368.116-.369.23-.746.345-1.114 2.028.538 4.145.72 6.082-.057-3.528 5.496-9.524 4.754-12.786 2.517-1.604-1.098-2.726-2.913-3.159-4.818-.524-2.292-.086-4.904 1.368-6.804l.002-.005Z",
    fill: "#3C3334"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pumpkins_svg__f)"
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.073 16.684c.588 1.361 4.004 2.91 4.983 3.557.98.647 2.035.977 3.069 1.23 4.32 1.064 8.857 1.009 12.47-1.922l3.23-2.656c-.99-.165-5.178-2.722-6.136-3.238a5.498 5.498 0 0 1-2.459-2.722c-.631-1.482-.686-3.36-.24-4.819.055-.165.11-.318.175-.472a4.278 4.278 0 0 0 .304-1.79 4.733 4.733 0 0 0-.588-2.195 3.482 3.482 0 0 0-.25-.395 2.692 2.692 0 0 0-.554-.56s-.022-.01-.033-.021c-.392-.297-.794-.604-1.208-.67-.533-.077-1.033.241-1.447.68-1.262 1.329-1.85 3.656-2.252 5.928-.403 2.283-.686 4.676-1.524 6.619-1.066 2.459-5.483 3.37-7.54 3.457v-.01Z",
    fill: "#715D98"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52.554 17.222a6.891 6.891 0 0 0 2.502 3.019c.99.647 2.035.977 3.069 1.23 2.089.515 4.232.767 6.3.57a21.97 21.97 0 0 1-2.873-.527c-1.033-.252-2.078-.582-3.068-1.23-.99-.647-1.915-1.657-2.514-3.018 2.057-.088 3.994-1.537 5.06-4.006.838-1.932 1.12-4.336 1.523-6.608.36-2.075.892-4.193 1.937-5.554a2.425 2.425 0 0 0-.413-.406c-.011 0-.022-.011-.033-.022-.392-.297-.784-.604-1.208-.67-.533-.077-1.034.241-1.447.68-1.262 1.329-1.85 3.656-2.252 5.928-.403 2.283-.675 4.676-1.524 6.619-1.066 2.458-3.014 3.907-5.06 3.995Z",
    fill: "#715D98",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.16 17.321c.848-.285 1.512-1.142 1.947-2.228.892-2.272.73-5.148 1.132-7.706.196-1.251.587-2.316.99-3.403.272-.746.522-1.503.664-2.327a3.483 3.483 0 0 0-.25-.395c-.142 1.076-.512 2.02-.86 2.953-.381 1.043-.708 2.086-.87 3.271-.175 1.23-.23 2.492-.349 3.743-.218 2.316-.773 5.071-2.459 5.642-.185.066-.12.505.054.45Z",
    fill: "#715D98",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.348 15.159c.424-.79.696-1.735.826-2.756.12-.944.077-1.899-.032-2.886-.12-1-.218-1.998.054-2.91.305-1.042.892-1.8 1.284-2.743 0-.264-.032-.516-.076-.769-.185.626-.479 1.153-.75 1.68-.316.57-.62 1.163-.795 1.877-.218.889-.12 1.855-.01 2.81.119 1.02.173 1.998.02 2.985-.13.9-.39 1.724-.76 2.426-.11.22.13.505.25.286h-.011ZM63.63 16.059c.838-1.274 1.24-3.129 1.089-5.017-.022-.285.272-.329.293-.043.163 2.052-.272 4.039-1.186 5.422-.13.198-.326-.176-.196-.362ZM59.92 7.3c.294-1.362.381-2.855.773-4.15.326-1.064.86-2.02 1.643-2.327.185-.066.315.351.13.417-1.773.692-1.806 4.062-2.274 6.246-.054.263-.337.077-.283-.187h.011ZM59.844 13.809c.914-1.395 1.132-3.491 1.295-5.423.174-1.954.348-3.973 1.131-5.532.11-.22.36.066.25.285-1.599 3.162-.576 8.123-2.48 11.032-.13.197-.326-.176-.196-.362ZM58.8 14.862a35.315 35.315 0 0 1 1.044-5.993c.065-.252.348-.066.283.187a34.922 34.922 0 0 0-1.023 5.883c-.022.274-.326.198-.304-.077Z",
    fill: "#715D98",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M95 37.968C95 50.163 86.59 58 76.209 58c-.99 0-1.97-.077-2.916-.209a18.481 18.481 0 0 1-3.896-1.01c-2.11.802-4.406 1.219-6.8 1.219a19.41 19.41 0 0 1-5.908-.911c-1.437.45-2.95.746-4.505.856-.457.033-.925.055-1.404.055C40.41 58 32 50.163 32 37.968s8.41-24.149 18.791-24.149c.914 0 1.806.088 2.688.275 1.11.22 2.187.582 3.22 1.054 1.861-.857 3.841-1.329 5.909-1.329 2.394 0 4.7.637 6.8 1.768a15.915 15.915 0 0 1 2.797-1.175 13.667 13.667 0 0 1 4.004-.604C86.589 13.809 95 25.752 95 37.958v.01Z",
    fill: "#F68F38"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75.686 14.742c-2.295 0-4.504.614-6.517 1.7-2.024-1.086-4.222-1.7-6.518-1.7-1.98 0-3.884.45-5.658 1.273-1.784-.813-3.688-1.274-5.658-1.274-9.967 0-18.03 11.449-18.03 23.139s8.063 19.198 18.008 19.198c1.98 0 3.885-.296 5.658-.867 1.785.57 3.678.867 5.659.867 2.295 0 4.504-.406 6.517-1.175a18.566 18.566 0 0 0 6.518 1.175c9.945 0 18.007-7.508 18.007-19.198 0-11.69-8.062-23.139-18.007-23.139h.021Z",
    fill: "#F68F38",
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M83.619 38.21c0 9.055-4.146 15.96-10.315 19.57a18.48 18.48 0 0 1-3.896-1.01c-2.11.802-4.406 1.219-6.8 1.219a19.41 19.41 0 0 1-5.908-.911c-1.437.45-2.95.746-4.505.856-6.333-3.578-10.598-10.548-10.598-19.736 0-9.802 4.853-19.461 11.893-24.115 1.11.22 2.187.582 3.22 1.054 1.861-.857 3.841-1.329 5.909-1.329 2.394 0 4.7.637 6.8 1.768a15.915 15.915 0 0 1 2.797-1.175c6.778 4.775 11.403 14.215 11.403 23.786v.022Z",
    fill: "url(#pumpkins_svg__g)"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M81.388 37.968C81.388 50.163 72.978 58 62.597 58c-10.38 0-18.791-7.837-18.791-20.032s8.41-24.149 18.79-24.149c10.381 0 18.792 11.943 18.792 24.149Z",
    fill: "#F68F38"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M80.605 37.88c0 11.69-8.063 19.198-18.008 19.198-9.945 0-18.008-7.508-18.008-19.198 0-3.721.816-7.42 2.252-10.724 3.069-7.09 8.977-12.414 15.756-12.414s12.687 5.323 15.755 12.414c1.437 3.304 2.253 7.003 2.253 10.724Z",
    fill: "#F68F38",
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.733 31.37c.087.517-1.034 1.91-1.327 2.328a14.816 14.816 0 0 1-1.807 2.075c-1.327 1.262-5.288 3.984-5.288 3.984s.642 2.03.588 2.151c-.055.1-3.612.911-5.016.955l-.49-2.656c-1 .143-3.96.033-3.96.033l-.48 2.667a19.27 19.27 0 0 1-4.428-1.47c.12-.703.25-1.417.37-2.119-3.819-.812-7.486-2.283-10.043-5.181 1.208 11.975 11.784 15.773 19.085 14.83 3.59-.462 6.986-2.503 9.314-5.27 2.807-3.325 4.287-7.98 3.482-12.315v-.011Z",
    fill: "url(#pumpkins_svg__h)",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.363 27.156c-3.068 5.927-8.977 9.418-15.755 9.418-6.779 0-12.687-3.49-15.756-9.418 3.069-7.09 8.977-12.414 15.756-12.414s12.687 5.323 15.755 12.414Z",
    fill: "#F68F38",
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.627 28.484c-.11-.154-2.46-2.151-4.222-3.622-1.088-.911-2.731-.68-3.493.527-.022.044-.044.077-.054.099-.816 1.855-1.186 4.072-.283 5.993.522 1.108 1.49 1.975 2.698 2.195 2.285.417 4.222-1.504 5.168-3.38.283-.572.534-1.274.185-1.812Z",
    fill: "url(#pumpkins_svg__i)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M59.344 28.341c-.098-.153-2.307-2.02-3.961-3.402-1.023-.857-2.568-.637-3.286.494-.022.044-.044.066-.054.087-.762 1.746-1.121 3.831-.262 5.631.49 1.043 1.404 1.855 2.536 2.064 2.143.384 3.96-1.416 4.852-3.172.273-.538.501-1.197.175-1.702Z",
    fill: "#3C3334"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M66.525 28.506c.098-.165 2.437-2.162 4.2-3.655a2.353 2.353 0 0 1 3.503.505c.022.044.044.077.055.099.827 1.855 1.208 4.072.315 5.993-.522 1.108-1.48 1.986-2.676 2.217-2.285.428-4.233-1.482-5.19-3.348-.294-.57-.544-1.273-.196-1.81h-.011Z",
    fill: "url(#pumpkins_svg__j)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M66.797 28.363c.098-.153 2.296-2.03 3.939-3.435 1.012-.867 2.568-.648 3.286.472.021.044.043.066.054.088.773 1.734 1.143 3.82.294 5.63-.49 1.043-1.393 1.866-2.514 2.075-2.143.406-3.971-1.394-4.874-3.14-.272-.526-.512-1.196-.185-1.7v.01ZM63.718 35.158a2.945 2.945 0 0 1-1.687.022 1.185 1.185 0 0 1-.805-1.416c.12-.516.348-1.021.685-1.493.49-.692 1.524-.67 2.002.033.294.439.501.889.642 1.328a1.229 1.229 0 0 1-.827 1.526h-.01Z",
    fill: "#3C3334"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M78.929 30.657c.087.516-1.034 1.91-1.328 2.327a14.816 14.816 0 0 1-1.806 2.075c-1.327 1.262-5.865 4.116-5.865 4.116s.642 2.03.588 2.152c-.054.098-3.036.779-4.44.823l-.489-2.656c-1.001.142-3.96.032-3.96.032l-.48 2.668a19.27 19.27 0 0 1-4.428-1.471c.12-.703.25-1.416.37-2.118-3.82-.813-7.486-2.284-10.043-5.181 1.208 11.975 11.784 15.773 19.085 14.829 3.59-.461 6.986-2.503 9.314-5.269 2.807-3.326 4.287-7.98 3.482-12.316v-.01Z",
    fill: "#3C3334"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "pumpkins_svg__b",
    x1: 27.545,
    y1: 30.077,
    x2: 15.55,
    y2: 54.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FEFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FDF4F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#FCE6E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#F9D3CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F7B9B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#F39B92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#EF766C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB5143"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pumpkins_svg__c",
    x1: 21.994,
    y1: 41.448,
    x2: 17.352,
    y2: 49.852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#FDEEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F8C5C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F4A199"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#F0847A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EE6D61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#EC5D50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#EB5446"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB5143"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pumpkins_svg__d",
    x1: 28.605,
    y1: 39.191,
    x2: 23.1,
    y2: 45.399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#FDEEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F8C5C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F4A199"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#F0847A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EE6D61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#EC5D50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#EB5446"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB5143"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pumpkins_svg__e",
    x1: 19.709,
    y1: 34.698,
    x2: 17.868,
    y2: 42.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#FDEEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F8C5C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F4A199"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#F0847A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EE6D61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#EC5D50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#EB5446"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB5143"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pumpkins_svg__g",
    x1: 63.25,
    y1: 8.935,
    x2: 62.109,
    y2: 59.888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FEFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FDF4F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#FCE6E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#F9D3CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F7B9B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#F39B92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#EF766C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB5143"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pumpkins_svg__h",
    x1: 62.847,
    y1: 32.249,
    x2: 63.434,
    y2: 49.932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#FDEEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F8C5C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F4A199"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#F0847A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EE6D61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#EC5D50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#EB5446"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB5143"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pumpkins_svg__i",
    x1: 53.786,
    y1: 23.013,
    x2: 57.598,
    y2: 37.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#FDEEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F8C5C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F4A199"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#F0847A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EE6D61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#EC5D50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#EB5446"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB5143"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pumpkins_svg__j",
    x1: 72.343,
    y1: 23.076,
    x2: 68.634,
    y2: 37.918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#FDEEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F8C5C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#F4A199"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#F0847A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EE6D61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#EC5D50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#EB5446"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB5143"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "pumpkins_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "scale(-1 1) rotate(-26.997 47.168 109.793)",
    d: "M0 0h33.835v31.474H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "pumpkins_svg__f"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(32)",
    d: "M0 0h63v58H0z"
  })))));
};
export default SvgPumpkins;